import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import ScoreSelector from '../../../Score/ScoreSelector';
import { useApiClient } from '../../../../context/ApiClientContext';

function AddScoreToReportForm(props) {
  const { actionListId, onSuccess } = props;

  const apiClient = useApiClient();

  const handleSubmit = (reportSection, scoreId) => apiClient.addScoreToReportAction(
    actionListId,
    reportSection,
    scoreId,
  );

  return (
    <Grid container>
      <Grid item xs={6}>
        <ScoreSelector
          handleSubmit={handleSubmit}
          buttonText="Add"
          successMsg="Score added"
          reloadCallback={onSuccess}
        />
      </Grid>
    </Grid>
  );
}

AddScoreToReportForm.propTypes = {
  actionListId: PropTypes.number.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default AddScoreToReportForm;
